<div
  *ngIf="title && title !== 'administration'"
  [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
>
  <nb-card
    class="personal-info-card padd-personal-info table-border-radius w-100 scrollable-card"
  >
    <div class="info-label d-flex pb-1 justify-content-between">
      <label class="personal-info quicksand-bold-label info-color"
        >Personal Information</label
      >
      <img
        src="/assets/icons/edit-note.svg"
        alt="edit-info"
        height="17"
        width="17"
        class="cursor-pointer img-dark"
        (click)="currentProfile = null; patchProfileForm()"
      />
    </div>

    <div class="row pt-3 pb-2">
      <div
        class="col-md-4 col-lg-3 col-xl-3 col-xxl-2 text-center profile-img-content"
      >
        <figure>
          <img
            [src]="user && user.user_profile_media ? user.user_profile_media.image.url : '/assets/images/profile.png'"
            (click)="isModalOpen = false; fileInput.click()"
            alt="profile-picture"
            class="cursor-pointer rounded-circle img-profile"
            [ngClass]="user?.user_profile_media_id !== 0 ? 'image-valid' : 'image-invalid'"
          />
          <figcaption class="quicksand-bold-label mt-2">
            {{ user ? user.firstName : '' }} {{ user ? user.lastName : '' }}
          </figcaption>
        </figure>
      </div>

      <div class="col-md-8 col-lg-9 col-xl-9 col-xxl-10">
        <div class="row py-2 m-1 pb-4 personal-info-content">
          <div class="col-md-3">
            <label class="quicksand-normal-label form-labels">Email ID:</label>
            <div class="quicksand-bold-label user-email">
              {{ user ? user.email : '' }}
            </div>
          </div>
          <div class="col-md-3">
            <label class="quicksand-normal-label form-labels"
              >School-Issued ID:</label
            >
            <div class="quicksand-bold-label">
              {{ user?.school_indentity_number ? user.school_indentity_number : '-' }}
            </div>
          </div>
          <div class="col-md-3">
            <label class="quicksand-normal-label form-labels"
              >Phone Number:</label
            >
            <div class="quicksand-bold-label">
              {{ user?.contact && user?.contact !== 0 
      ? (user?.contact | mask : '(000) 000-0000') 
      : '-' }}
            </div>
          </div>

          <div class="col-md-3">
            <label class="quicksand-normal-label form-labels"
              >Birth Date:</label
            >
            <div class="quicksand-bold-label">
              {{ user?.birthdate ? (user?.birthdate | date : 'MM-dd-yyyy') : '-' }}
            </div>
          </div>
        </div>

        <div class="row p-3">
          <div class="col-md-4 dates-">
            <div class="row mt-1">
              <div class="col-md-6">
                <label class="quicksand-normal-label form-labels"
                  >Credential Document Number:</label
                >
              </div>
              <div class="col-md-6">
                <label
                  class="quicksand-bold-label ml-2"
                  >{{ user?.profileData?.credentialDocumentNumber || '-' }}</label
                >
              </div>
            </div>

            <!-- <div class="row mt-1">
              <div class="col-md-6">
                <label class="quicksand-normal-label form-labels"
                  >Credential Type and Employment Restriction:</label
                >
              </div>
              <div class="col-md-6">
                <label class="quicksand-bold-label ml-2 employment-label">{{
                  user ? user.profileData.credentialTypeEmployment : null
                }}</label>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-md-6">
                <label class="quicksand-normal-label form-labels"
                  >Credential Expiration Date:</label
                >
              </div>
              <div class="col-md-6">
                <label class="quicksand-bold-label ml-2">{{
                  user?.profileData?.credentialExpirationDate
                    | date : 'MM-dd-yyyy'
                }}</label>
              </div>
            </div> -->
          </div>

          <div class="col-md-4 dates-content">
            <div class="row mt-1">
              <div class="col-md-6">
                <label class="quicksand-normal-label form-labels"
                  >Date of Criminal Background Clearance:</label
                >
              </div>
              <div class="col-md-6">
                <label class="quicksand-bold-label ml-2"
                  >{{ user?.profileData?.dateOfCriminalBackground ? (user?.profileData?.dateOfCriminalBackground | date : 'MM-dd-yyyy') : '-' }}
                </label>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-md-6">
                <label class="quicksand-normal-label form-labels"
                  >Date of Hire:</label
                >
              </div>
              <div class="col-md-6">
                <label
                  class="quicksand-bold-label ml-2"
                  >{{ user?.profileData?.dateOfHire ?( user?.profileData?.dateOfHire | date : 'MM-dd-yyyy') : '-' }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-md-4 dates-content">
            <div class="row mt-1">
              <div class="col-md-6">
                <label class="quicksand-normal-label form-labels"
                  >TB Clearance Date:</label
                >
              </div>
              <div class="col-md-6">
                <label class="quicksand-bold-label ml-2"
                  >{{ user?.profileData?.tbClearanceDate ? (user?.profileData?.tbClearanceDate | date : 'MM-dd-yyyy') : '-' }}
                </label>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-md-6">
                <label class="quicksand-normal-label form-labels"
                  >TB Expiration Date:</label
                >
              </div>
              <div class="col-md-6">
                <label
                  class="quicksand-bold-label ml-2"
                  >{{ user?.profileData?.tbExpirationDate ? (user?.profileData?.tbExpirationDate | date : 'MM-dd-yyyy') : '-' }}</label
                >
              </div>
            </div>
          </div>
          <!-- <div *ngIf="user?.essa_grid?.subject_authorization?.length > 0" class="row m-1 pb-4 table-responsive">
            
            <table class="table h-100 m-0">
              <thead>
                <tr>
                  <th class="border-0"></th>
                  <th class="quicksand-bold-label text-center border-0">Authorization Code</th>
                  <th class="quicksand-bold-label text-center border-0">Authorization Description</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let auth of user?.essa_grid?.subject_authorization; let i = index">
                  <td>
                    <mat-checkbox class="auto-pilot custom-checkbox" [checked]="auth?.checked" disabled></mat-checkbox>
                  </td>
                  <td class="quicksand-normal-label mt-3 text-center">
                    {{ auth?.authorizationCode }}
                  </td>
                  <td class="quicksand-normal-label">
                    {{ auth?.authorizationDescription }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->
        </div>

        <!-- Credential document number information -->
        <div
          class="row m-1 mt-3 table-responsive border-0"
          *ngIf="savedValidatedTeacherData?.subject_authorization?.length > 0 && !storageService.detectMob()"
        >
          <table class="table h-100 m-0">
            <thead>
              <tr>
                <th class="d-none"></th>
                <th
                  class="quicksand-bold-label align-middle text-center border-0"
                >
                  Authorization Code
                </th>
                <th
                  class="quicksand-bold-label align-middle text-center border-0"
                >
                  Subject Description
                </th>
                <th
                  class="quicksand-bold-label align-middle text-center border-0"
                >
                  Authorization Description
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let auth of savedValidatedTeacherData?.subject_authorization; let i = index"
                [ngClass]="{
                  'd-none': !auth.authorizationCode && !auth.subjectDescription && !auth.authorizationDescription
                }"
              >
                <td class="d-none"></td>
                <td class="quicksand-normal-label mt-3 text-center">
                  {{ auth?.authorizationCode }}
                </td>
                <td class="quicksand-normal-label text-center">
                  {{ auth.subjectDescription ? auth.subjectDescription : '-' }}
                </td>
                <td class="quicksand-normal-label">
                  {{ auth?.authorizationDescription }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          class="m-1 mt-3"
          *ngIf="savedValidatedTeacherData?.subject_authorization?.length > 0 && storageService.detectMob()"
        >
          <div
            class="mobile-card"
            *ngFor="let auth of savedValidatedTeacherData?.subject_authorization"
            [ngClass]="{
              'd-none': !auth.authorizationCode && !auth.subjectDescription && !auth.authorizationDescription
            }"
          >
            <div class="col-12">
              <label class="quicksand-bold-label">Authorization Code:</label>
              <div class="quicksand-normal-label">
                {{ auth?.authorizationCode }}
              </div>
            </div>

            <div class="col-12">
              <label class="quicksand-bold-label">Subject Description:</label>
              <div class="quicksand-normal-label">
                {{ auth.subjectDescription || '-' }}
              </div>
            </div>

            <div class="col-12">
              <label class="quicksand-bold-label"
                >Authorization Description:</label
              >
              <div class="quicksand-normal-label">
                {{ auth?.authorizationDescription }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nb-card>
</div>
<div
  class="container"
  *ngIf="title === 'administration'"
  [ngClass]="{
    'dark-theme': analyticsService?.currentTheme === 'material-dark',
    container: user?.is_trial_user && title === 'administration'
  }"
>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="2003"
  >
  </ngx-spinner>

  <div class="row w-100" *ngIf="title === 'administration'">
    <div class="col-md-4">
      <img
        src="/assets/images/RespondEDU-Logo-Colored.svg"
        alt="logo-img"
        height="100"
        width="200"
        style="border-radius: 50%"
      />
    </div>
    <div class="col-md-4 d-flex justify-content-center">
      <div class="w-100">
        <ngx-form-stepper></ngx-form-stepper>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>

  <div
    [ngClass]="{
      'admin-width': !user?.is_trial_user && title === 'administration'
    }"
  >
    <div
      class="trial-period-message mt-5"
      *ngIf="user?.is_trial_user && title === 'administration'"
    >
      <label class="quicksand-bold-label trial-period-label">
        Trial Period Users:
      </label>
      <label class="quicksand-normal-label trial-message"
        >This example displays the information you would input when creating
        your personal profile. You can skip it for now and continue by clicking
        “Next”.</label
      >
    </div>
    <div class="techer-personal-information">
      <div class="row justify-content-center">
        <div
          class="teacher-only-period-message mt-5"
          *ngIf="isTeacherOnlyUser && title === 'administration'"
        >
          <label class="quicksand-bold-label trial-period-label"> Note: </label>
          <label class="quicksand-normal-label trial-message"
            >Use this to securely store your credentials and personal
            information. Your data will remain completely private, so there’s no
            need to worry. If you prefer not to, you can skip this step and
            click “Next” to continue.</label
          >
        </div>
        <div class="col-lg-8 col-md-10 justify-content-center">
          <nb-card class="administration-form-content">
            <nb-card-header>
              <div class="d-flex">
                <h5 class="quicksand-bold-label ml-2">
                  <label>Personal Information</label>
                </h5>
              </div>
            </nb-card-header>
            <nb-card-body>
              <form class="form-horizontal" [formGroup]="teacherPortalInfoForm">
                <div class="row mb-4">
                  <div class="col-md-12 text-center position-relative">
                    <img
                      [src]="
                        currentProfile
                          ? currentProfile.image.url
                          : user && user.user_profile_media
                          ? user.user_profile_media.image.url
                          : '/assets/images/profile.png'
                      "
                      alt="profile-picture"
                      class="img-fluid round-image rounded-circle"
                    />

                    <div
                      (click)="isModalOpen = true; fileInput.click()"
                      class="change-profile cursor-pointer"
                    >
                      <img
                        src="/assets/icons/camera.svg"
                        alt="camera"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >First name <span class="required-field">*</span></label
                    >
                    <div class="col-sm-12">
                      <input
                        type="text"
                        nbInput
                        fullWidth
                        formControlName="firstName"
                        class="input-field"
                        maxlength="25"
                        [readonly]="teacherPortalInfoForm.controls.firstName.value?.length > 0 && !teacherPortalInfoForm.controls.firstName.dirty"
                        placeholder="Enter First Name"
                      />
                      <label
                        class="quicksand-bold-label error-label"
                        *ngIf="
                          teacherPortalInfoForm.controls.firstName.invalid &&
                          (teacherPortalInfoForm.controls.firstName.dirty || teacherPortalInfoForm.controls.firstName.touched)
                        "
                        >Enter Valid First Name</label
                      >
                    </div>
                  </div>

                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >Last name <span class="required-field">*</span></label
                    >
                    <div class="col-sm-12">
                      <input
                        type="text"
                        nbInput
                        fullWidth
                        formControlName="lastName"
                        class="input-field"
                        maxlength="25"
                        [readonly]="teacherPortalInfoForm.controls.lastName.value?.length > 0 && !teacherPortalInfoForm.controls.lastName.dirty"
                        placeholder="Enter Last Name"
                      />
                      <label
                        class="quicksand-bold-label error-label"
                        *ngIf="
                          teacherPortalInfoForm.controls.lastName.invalid &&
                          (teacherPortalInfoForm.controls.lastName.dirty || teacherPortalInfoForm.controls.lastName.touched)
                        "
                        >Enter Valid Last Name</label
                      >
                    </div>
                  </div>

                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >Email<span class="required-field">*</span></label
                    >
                    <div class="col-sm-12">
                      <input
                        type="text"
                        nbInput
                        fullWidth
                        formControlName="email"
                        class="input-field"
                        [readonly]="isTeacherOnlyUser"
                      />
                      <label
                        class="quicksand-bold-label error-label"
                        *ngIf="
                          teacherPortalInfoForm.controls.email.invalid &&
                          (teacherPortalInfoForm.controls.email.dirty || teacherPortalInfoForm.controls.email.touched)
                        "
                        >Enter Valid Email</label
                      >
                    </div>
                  </div>

                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >Phone no.</label
                    >
                    <div class="col-sm-12">
                      <input
                        type="text"
                        class="nb-input"
                        nbInput
                        fullWidth
                        formControlName="contact"
                        placeholder="Enter Phone Number"
                        mask="(000) 000-0000"
                      />
                    </div>
                  </div>

                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >Date of Birth</label
                    >
                    <div class="col-sm-12">
                      <div class="d-flex">
                        <input
                          matInput
                          [matDatepicker]="Birthdate"
                          formControlName="birthdate"
                          class="input-field w-100 mat-input-datepicker"
                          [max]="minBirthDate"
                          placeholder="Enter Date of Birth"
                          [readonly]="!isTeacherOnlyUser"
                          (dateChange)="onBirthDateChange($event)"
                        />

                        <mat-datepicker-toggle
                          class="mat-picker-toggle"
                          matSuffix
                          [for]="Birthdate"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #Birthdate></mat-datepicker>
                      </div>
                      <label
                        class="quicksand-bold-label error-label"
                        *ngIf="
                       teacherPortalInfoForm.controls.birthdate.invalid &&
                       (teacherPortalInfoForm.controls.birthdate.dirty || teacherPortalInfoForm.controls.birthdate.touched)
                     "
                      >
                        Enter valid date of birth
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >Home Address</label
                    >
                    <div class="col-sm-12">
                      <input
                        type="text"
                        nbInput
                        fullWidth
                        placeholder="Enter Home Address"
                        formControlName="address"
                        class="input-field"
                        maxlength="100"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >Date of Criminal Background Clearance</label
                    >
                    <div class="col-sm-12">
                      <div class="d-flex">
                        <input
                          matInput
                          [matDatepicker]="dateOfCriminalBackground"
                          fullWidth
                          formControlName="dateOfCriminalBackground"
                          class="input-field w-100 mat-input-datepicker"
                          [readonly]="!isTeacherOnlyUser"
                          [min]="newCriminalClearanceDate"
                          placeholder="Enter Date of Criminal Background Clearance"
                        />
                        <mat-datepicker-toggle
                          class="mat-picker-toggle"
                          matSuffix
                          [for]="dateOfCriminalBackground"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                          #dateOfCriminalBackground
                        ></mat-datepicker>
                      </div>
                      <label
                        class="quicksand-bold-label error-label"
                        *ngIf="
                       teacherPortalInfoForm.controls.dateOfCriminalBackground.invalid &&
                       (teacherPortalInfoForm.controls.dateOfCriminalBackground.dirty || teacherPortalInfoForm.controls.dateOfCriminalBackground.touched)
                     "
                      >
                        Enter valid date of Criminal Background Clearance
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >Date of Hire</label
                    >
                    <div class="col-sm-12">
                      <div class="d-flex">
                        <input
                          matInput
                          [matDatepicker]="dateOfHire"
                          fullWidth
                          class="input-field w-100 mat-input-datepicker"
                          formControlName="dateOfHire"
                          [min]="minDateOfHire"
                          [readonly]="!isTeacherOnlyUser"
                          placeholder="Enter Date of Hire"
                        />
                        <mat-datepicker-toggle
                          class="mat-picker-toggle"
                          matSuffix
                          [for]="dateOfHire"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                          #dateOfHire
                          [disabled]="!teacherPortalInfoForm.value.dateOfCriminalBackground"
                        ></mat-datepicker>
                      </div>
                      <label
                        class="quicksand-bold-label error-label"
                        *ngIf="
                       teacherPortalInfoForm.controls.dateOfHire.invalid &&
                       (teacherPortalInfoForm.controls.dateOfHire.dirty || teacherPortalInfoForm.controls.dateOfHire.touched)
                     "
                      >
                        Enter valid date of Hire
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >TB Clearance Date</label
                    >
                    <div class="col-sm-12">
                      <div class="d-flex">
                        <input
                          matInput
                          [matDatepicker]="tbClearanceDate"
                          fullWidth
                          formControlName="tbClearanceDate"
                          class="input-field w-100 mat-input-datepicker"
                          [min]="minDate"
                          [max]="currentDate"
                          (dateChange)="onTBClearanceDateChange($event)"
                          placeholder="Enter TB Clearance Date"
                          [readonly]="!isTeacherOnlyUser"
                        />
                        <mat-datepicker-toggle
                          class="mat-picker-toggle"
                          matSuffix
                          [for]="tbClearanceDate"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #tbClearanceDate></mat-datepicker>
                      </div>
                      <label
                        class="quicksand-bold-label error-label"
                        *ngIf="
                       teacherPortalInfoForm.controls.tbClearanceDate.invalid &&
                       (teacherPortalInfoForm.controls.tbClearanceDate.dirty || teacherPortalInfoForm.controls.tbClearanceDate.touched)
                     "
                      >
                        Enter valid date of TB Clearance
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >TB Expiration Date</label
                    >
                    <div class="col-sm-12">
                      <div class="d-flex">
                        <input
                          matInput
                          [matDatepicker]="tbExpirationDate"
                          fullWidth
                          formControlName="tbExpirationDate"
                          class="input-field w-100 mat-input-datepicker"
                          [min]="maxDateTbExpiration"
                          [readonly]="!isTeacherOnlyUser"
                          placeholder="Enter TB Expiration Date"
                        />
                        <mat-datepicker-toggle
                          class="mat-picker-toggle"
                          matSuffix
                          [for]="tbExpirationDate"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #tbExpirationDate></mat-datepicker>
                      </div>
                      <label
                        class="quicksand-bold-label error-label"
                        *ngIf="
                       teacherPortalInfoForm.controls.tbExpirationDate.invalid &&
                       (teacherPortalInfoForm.controls.tbExpirationDate.dirty || teacherPortalInfoForm.controls.tbExpirationDate.touched)
                     "
                      >
                        Enter valid date of TB Expiration
                      </label>
                    </div>
                  </div>
                </div>

                <!-- credentail document number  -->
                <div class="form-group row">
                  <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >Credential Document Number</label
                    >
                    <div class="col-sm-12">
                      <input
                        nbInput
                        fullWidth
                        class="input-field"
                        formControlName="credentialDocumentNumber"
                        placeholder="Enter Credential Document Number"
                        maxlength="13"
                        [readonly]="savedValidatedTeacherData"
                      />
                      <button
                        *ngIf="
                          teacherPortalInfoForm.get('credentialDocumentNumber').value &&
                          teacherPortalInfoForm.get('credentialDocumentNumber').value?.length >= 9 &&
                          !savedValidatedTeacherData
                        "
                        class="save-changes-btn my-2 w-100 quicksand-bold-label"
                        nbButton
                        fullWidth
                        color="warn"
                        type="submit"
                       [disabled]="user.is_trial_user"
                        (click)="validateCredentialDocumentNumber()"
                      >
                        Validate
                      </button>
                    </div>
                  </div>

                  <div class="col-md-6 p-0" *ngIf="savedValidatedTeacherData">
                    <label class="label col-sm-12 form-control-label"
                      >Expiration Date</label
                    >

                    <div class="col-sm-12">
                      <input
                        type="text"
                        nbInput
                        fullWidth
                        class="input-field"
                        [value]="savedValidatedTeacherData.doj_expiration"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="col-md-6 p-0" *ngIf="savedValidatedTeacherData">
                    <label class="label col-sm-12 form-control-label"
                      >Issue Date</label
                    >
                    <div class="col-sm-12">
                      <input
                        type="text"
                        nbInput
                        fullWidth
                        class="input-field"
                        [value]="savedValidatedTeacherData.date_of_hire"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="col-md-6 p-0" *ngIf="savedValidatedTeacherData">
                    <label class="label col-sm-12 form-control-label"
                      >Status</label
                    >
                    <div class="col-sm-12">
                      <input
                        type="text"
                        nbInput
                        fullWidth
                        class="input-field"
                        [value]="savedValidatedTeacherData.status"
                        readonly
                      />
                    </div>
                  </div>
                  <div
                    class="table-responsive m-3"
                    *ngIf="
                      savedValidatedTeacherData && savedValidatedTeacherData.subject_authorization && savedValidatedTeacherData.subject_authorization.length > 0
                    "
                  >
                    <table class="table h-100 m-0">
                      <thead>
                        <tr>
                          <th class="border-0"></th>
                          <th class="quicksand-bold-label text-center border-0">
                            Authorization Code
                          </th>
                          <th class="quicksand-bold-label text-center border-0">
                            Subject Description
                          </th>
                          <th class="quicksand-bold-label text-center border-0">
                            Authorization Description
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let auth of savedValidatedTeacherData.subject_authorization"
                        >
                          <td>
                            <mat-checkbox
                              class="auto-pilot custom-checkbox"
                              [checked]="auth.checked"
                              disabled
                            ></mat-checkbox>
                          </td>
                          <td class="quicksand-normal-label mt-3">
                            {{ auth.authorizationCode }}
                          </td>
                          <td class="quicksand-normal-label text-center">
                            {{ auth.subjectDescription ? auth.subjectDescription : '-' }}
                          </td>
                          <td class="quicksand-normal-label">
                            {{ auth.authorizationDescription }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >Credential Type and Employment Restriction</label
                    >
                    <div class="col-sm-12">
                      <input
                        type="text"
                        nbInput
                        fullWidth
                        formControlName="credentialTypeEmployment"
                        placeholder="Enter Credential Type and Employment Restriction"
                        class="input-field"
                        maxlength="50"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="col-md-6 p-0">
                    <label class="label col-sm-12 form-control-label"
                      >Credential Expiration Date</label
                    >
                    <div class="col-sm-12">
                      <div class="d-flex">
                        <input
                          matInput
                          [matDatepicker]="credentialExpirationDate"
                          fullWidth
                          formControlName="credentialExpirationDate"
                          class="input-field w-100 mat-input-datepicker"
                          placeholder="Enter Credential Expiration Date"
                          [readonly]="!isTeacherOnlyUser"
                        />
                        <mat-datepicker-toggle
                          class="mat-picker-toggle"
                          matSuffix
                          [for]="credentialExpirationDate"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                          #credentialExpirationDate
                        ></mat-datepicker>
                      </div>
                    </div>
                  </div> -->
                </div>
              </form>
            </nb-card-body>
            <nb-card-footer>
              <button
                class="skip quicksand-bold-label text-capitalize text-white {{ user?.is_trial_user ? 'skip' : 'skip-btn-active' }}"
                title="Skip personal information form, you can add it in your profile again"
                (click)="router.navigateByUrl('/administration/teacher-academic-portal')"
              >
                Skip
              </button>
              <button
                nbButton
                color="warn"
                class="save-changes-btn quicksand-bold-label float-right"
                (click)="submit()"
                [title]="teacherPortalInfoForm.invalid ? 'Please fill all the required fields with *' : 'Save Changes'"
              >
                Save Changes
              </button>
            </nb-card-footer>
          </nb-card>
        </div>
      </div>
    </div>

    <div *ngIf="user?.is_trial_user">
      <button
        nbButton
        color="primary"
        class="Next quicksand-bold-label text-capitalize text-white"
        title="Skip personal information form, you can add it in your profile again"
        (click)="router.navigateByUrl('/administration/teacher-academic-portal')"
      >
        Next
      </button>
    </div>
  </div>
</div>

<div class="text-center">
  <span
    style="visibility: hidden; position: absolute; overflow: hidden; width: 0px; height: 0px; border: none; margin: 0; padding: 0"
  >
    <input
      type="file"
      name="file"
      accept="image/*"
      #fileInput
      (change)="pickFiles($event)"
      class="inputfile"
    />
  </span>
</div>

<!-- update user modal -->
<ng-template #myModal let-modal>
  <div
    class="add-classroom-modal personal-information-modal"
    [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
  >
    <div
      class="modal-header d-flex justify-content-between align-items-center w-100"
    >
      <div class="d-flex align-items-center">
        <span class="icon-add-classroom">
          <nb-icon icon="plus-outline"></nb-icon>
        </span>
        <h6 class="add-clasroom-text quicksand-bold-label m-0">
          Personal Information
        </h6>
      </div>

      <span
        class="icon-close-classroom-modal d-block cursor-pointer"
        (click)="modalService.dismissAll(modalRef); deleteProfileIfExist(); teacherPortalInfoForm.reset()"
      >
        <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
      </span>
    </div>

    <div class="modal-body">
      <form class="form-horizontal" [formGroup]="teacherPortalInfoForm">
        <div class="row mb-4">
          <div class="col-md-12 text-center">
            <img
              [src]="
                currentProfile ? currentProfile.image.url : user && user.user_profile_media ? user.user_profile_media.image.url : '/assets/images/profile.png'
              "
              alt="profile-picture"
              class="round-image rounded-circle image-valid-profile hover-effect"
            />

            <div
              (click)="isModalOpen = true; fileInput.value = ''; fileInput.click()"
              class="change-profile cursor-pointer hover-effect"
            >
              <img src="/assets/icons/camera.svg" alt="camera" loading="lazy" />
            </div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-6 p-0">
            <label class="label col-sm-12 form-control-label"
              >First name <span class="required-field">*</span></label
            >
            <div class="col-sm-12">
              <input
                type="text"
                nbInput
                fullWidth
                formControlName="firstName"
                class="input-field"
                maxlength="25"
              />
              <label
                class="quicksand-bold-label error-label"
                *ngIf="
                  teacherPortalInfoForm.controls.firstName.invalid &&
                  (teacherPortalInfoForm.controls.firstName.dirty || teacherPortalInfoForm.controls.firstName.touched)
                "
                >Enter Valid First Name</label
              >
            </div>
          </div>

          <div class="col-md-6 p-0">
            <label class="label col-sm-12 form-control-label"
              >Last name <span class="required-field">*</span></label
            >
            <div class="col-sm-12">
              <input
                type="text"
                nbInput
                fullWidth
                formControlName="lastName"
                class="input-field"
                maxlength="25"
              />
              <label
                class="quicksand-bold-label error-label"
                *ngIf="
                  teacherPortalInfoForm.controls.lastName.invalid &&
                  (teacherPortalInfoForm.controls.lastName.dirty || teacherPortalInfoForm.controls.lastName.touched)
                "
                >Enter Valid Last Name</label
              >
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="label col-sm-12 form-control-label"
            >Email<span class="required-field">*</span></label
          >
          <div class="col-sm-12">
            <input
              type="text"
              nbInput
              fullWidth
              formControlName="email"
              class="input-field"
              readonly
            />
            <label
              class="quicksand-bold-label error-label"
              *ngIf="
                teacherPortalInfoForm.controls.email.invalid && (teacherPortalInfoForm.controls.email.dirty || teacherPortalInfoForm.controls.email.touched)
              "
              >Enter Valid Email</label
            >
          </div>
        </div>

        <div class="form-group row">
          <label class="label col-sm-12 form-control-label"
            >School-Issued ID <span class="required-field">*</span></label
          >
          <div class="col-sm-12">
            <input
              type="text"
              nbInput
              fullWidth
              formControlName="id_code"
              placeholder="Enter Your Unique Id Code"
              maxlength="12"
              class="input-field"
            />
            <label
              class="quicksand-bold-label error-label"
              *ngIf="
                teacherPortalInfoForm.controls.id_code.invalid &&
                (teacherPortalInfoForm.controls.id_code.dirty || teacherPortalInfoForm.controls.id_code.touched)
              "
              >Enter Your Valid School-Issued ID upto 12 Digit</label
            >
          </div>
        </div>

        <div class="form-group row">
          <label class="label col-sm-12 form-control-label">Phone no.</label>
          <div class="col-sm-12">
            <input
              type="text"
              class="nb-input"
              nbInput
              fullWidth
              formControlName="contact"
              placeholder="Enter Phone Number"
              mask="(000) 000-0000"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="label col-sm-12 form-control-label"
            >Date of Birth</label
          >
          <div class="col-sm-12">
            <div class="d-flex">
              <input
                matInput
                [matDatepicker]="Birthdate"
                formControlName="birthdate"
                class="input-field w-100 mat-input-datepicker"
                [max]="minBirthDate"
                [readonly]="true"
              />

              <mat-datepicker-toggle
                class="mat-picker-toggle"
                matSuffix
                [for]="Birthdate"
              ></mat-datepicker-toggle>
              <mat-datepicker #Birthdate></mat-datepicker>
            </div>
            <label
              class="quicksand-bold-label error-label"
              *ngIf="
                       teacherPortalInfoForm.controls.birthdate.invalid &&
                       (teacherPortalInfoForm.controls.birthdate.dirty || teacherPortalInfoForm.controls.birthdate.touched)
                     "
            >
              Enter valid date of birth
            </label>
          </div>
        </div>

        <div class="form-group row">
          <label class="label col-sm-12 form-control-label">Home Address</label>
          <div class="col-sm-12">
            <input
              type="text"
              nbInput
              fullWidth
              formControlName="address"
              class="input-field"
              maxlength="100"
            />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-6 p-0">
            <label class="label col-sm-12 form-control-label"
              >Date of Criminal Background Clearance</label
            >
            <div class="col-sm-12">
              <div class="d-flex">
                <input
                  matInput
                  [matDatepicker]="dateOfCriminalBackground"
                  fullWidth
                  formControlName="dateOfCriminalBackground"
                  class="input-field w-100 mat-input-datepicker"
                  [readonly]="true"
                  [min]="minDateOfTB"
                />
                <mat-datepicker-toggle
                  class="mat-picker-toggle"
                  matSuffix
                  [for]="dateOfCriminalBackground"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateOfCriminalBackground></mat-datepicker>
              </div>
              <label
                class="quicksand-bold-label error-label"
                *ngIf="
                       teacherPortalInfoForm.controls.dateOfCriminalBackground.invalid &&
                       (teacherPortalInfoForm.controls.dateOfCriminalBackground.dirty || teacherPortalInfoForm.controls.dateOfCriminalBackground.touched)
                     "
              >
                Enter valid date of Criminal Background Clearance
              </label>
            </div>
          </div>

          <div class="col-md-6 p-0">
            <label class="label col-sm-12 form-control-label"
              >Date of Hire</label
            >

            <div class="col-sm-12">
              <div class="d-flex">
                <input
                  matInput
                  [matDatepicker]="dateOfHire"
                  fullWidth
                  class="input-field w-100 mat-input-datepicker"
                  formControlName="dateOfHire"
                  [min]="minDateOfHire"
                  [readonly]="true"
                />
                <mat-datepicker-toggle
                  class="mat-picker-toggle"
                  matSuffix
                  [for]="dateOfHire"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #dateOfHire
                  [disabled]="!teacherPortalInfoForm.value.dateOfCriminalBackground"
                ></mat-datepicker>
              </div>
              <label
                class="quicksand-bold-label error-label"
                *ngIf="
                       teacherPortalInfoForm.controls.dateOfHire.invalid &&
                       (teacherPortalInfoForm.controls.dateOfHire.dirty || teacherPortalInfoForm.controls.dateOfHire.touched)
                     "
              >
                Enter valid date of Hire
              </label>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-6 p-0">
            <label class="label col-sm-12 form-control-label"
              >TB Clearance Date
            </label>
            <div class="col-sm-12">
              <div class="d-flex">
                <input
                  matInput
                  [matDatepicker]="tbClearanceDate"
                  fullWidth
                  formControlName="tbClearanceDate"
                  class="input-field w-100 mat-input-datepicker"
                  [min]="minDateOfTB"
                  [max]="currentDate"
                  (dateChange)="onTBClearanceDateChange($event)"
                  [readonly]="true"
                />
                <mat-datepicker-toggle
                  class="mat-picker-toggle"
                  matSuffix
                  [for]="tbClearanceDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #tbClearanceDate></mat-datepicker>
              </div>
              <label
                class="quicksand-bold-label error-label"
                *ngIf="
                       teacherPortalInfoForm.controls.tbClearanceDate.invalid &&
                       (teacherPortalInfoForm.controls.tbClearanceDate.dirty || teacherPortalInfoForm.controls.tbClearanceDate.touched)
                     "
              >
                Enter valid date of TB Clearance
              </label>
            </div>
          </div>

          <div class="col-md-6 p-0">
            <label class="label col-sm-12 form-control-label"
              >TB Expiration Date
            </label>
            <div class="col-sm-12">
              <div class="d-flex">
                <input
                  matInput
                  [matDatepicker]="tbExpirationDate"
                  fullWidth
                  formControlName="tbExpirationDate"
                  class="input-field w-100 mat-input-datepicker"
                  [min]="maxDateTbExpiration"
                  [readonly]="true"
                />
                <mat-datepicker-toggle
                  class="mat-picker-toggle"
                  matSuffix
                  [for]="tbExpirationDate"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #tbExpirationDate
                  [disabled]="!teacherPortalInfoForm.value.tbClearanceDate"
                ></mat-datepicker>
              </div>
              <label
                class="quicksand-bold-label error-label"
                *ngIf="
                       teacherPortalInfoForm.controls.tbExpirationDate.invalid &&
                       (teacherPortalInfoForm.controls.tbExpirationDate.dirty || teacherPortalInfoForm.controls.tbExpirationDate.touched)
                     "
              >
                Enter valid date of TB Expiration
              </label>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="label col-sm-12 form-control-label"
            >Credential Document Number</label
          >
          <div class="col-sm-12">
            <input
              nbInput
              fullWidth
              class="input-field"
              formControlName="credentialDocumentNumber"
              placeholder="Enter Credential Document Number"
              maxlength="13"
              [readonly]="savedValidatedTeacherData"
            />
            <button
              *ngIf="
                teacherPortalInfoForm.get('credentialDocumentNumber').value &&
                teacherPortalInfoForm.get('credentialDocumentNumber').value?.length >= 9 &&
                !savedValidatedTeacherData
              "
              class="save-changes-btn my-2 w-100 quicksand-bold-label"
              nbButton
              fullWidth
              color="warn"
              type="submit"
              (click)="validateCredentialDocumentNumber()"
            >
              Validate
            </button>
          </div>

          <div class="col-md-6 p-0" *ngIf="savedValidatedTeacherData">
            <label class="label col-sm-12 form-control-label"
              >Expiration Date</label
            >

            <div class="col-sm-12">
              <input
                type="text"
                nbInput
                fullWidth
                class="input-field"
                [value]="savedValidatedTeacherData.doj_expiration"
                readonly
              />
            </div>
          </div>

          <div class="col-md-6 p-0" *ngIf="savedValidatedTeacherData">
            <label class="label col-sm-12 form-control-label">Issue Date</label>
            <div class="col-sm-12">
              <input
                type="text"
                nbInput
                fullWidth
                class="input-field"
                [value]="savedValidatedTeacherData.date_of_hire"
                readonly
              />
            </div>
          </div>

          <div class="col-md-6 p-0" *ngIf="savedValidatedTeacherData">
            <label class="label col-sm-12 form-control-label">Status</label>
            <div class="col-sm-12">
              <input
                type="text"
                nbInput
                fullWidth
                class="input-field"
                [value]="savedValidatedTeacherData.status"
                readonly
              />
            </div>
          </div>
          <div
            class="table-responsive m-3"
            *ngIf="savedValidatedTeacherData && savedValidatedTeacherData.subject_authorization && savedValidatedTeacherData.subject_authorization.length > 0"
          >
            <table class="table h-100 m-0">
              <thead>
                <tr>
                  <th class="border-0"></th>
                  <th class="quicksand-bold-label text-center border-0">
                    Authorization Code
                  </th>
                  <th class="quicksand-bold-label text-center border-0">
                    Subject Description
                  </th>
                  <th class="quicksand-bold-label text-center border-0">
                    Authorization Description
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let auth of savedValidatedTeacherData.subject_authorization"
                >
                  <td>
                    <mat-checkbox
                      class="auto-pilot custom-checkbox"
                      [checked]="auth.checked"
                      disabled
                    ></mat-checkbox>
                  </td>
                  <td class="quicksand-normal-label mt-3">
                    {{ auth.authorizationCode }}
                  </td>
                  <td class="quicksand-normal-label text-center">
                    {{ auth.subjectDescription ? auth.subjectDescription : '-' }}
                  </td>
                  <td class="quicksand-normal-label">
                    {{ auth.authorizationDescription }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <div class="col-sm-12">
            <input type="text" nbInput fullWidth class="input-field" formControlName="credentialDocumentNumber" maxlength="13" />
          </div> -->
        </div>

        <!-- <div class="form-group row">
          <label class="label col-sm-12 form-control-label"
            >Credential Type and Employment Restriction
          </label>
          <div class="col-sm-12">
            <input
              type="text"
              nbInput
              fullWidth
              formControlName="credentialTypeEmployment"
              class="input-field"
              maxlength="50"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="label col-sm-12 form-control-label"
            >Credential Expiration Date
          </label>
          <div class="col-sm-12">
            <div class="d-flex">
              <input
                matInput
                [matDatepicker]="credentialExpirationDate"
                fullWidth
                formControlName="credentialExpirationDate"
                class="input-field w-100 mat-input-datepicker"
                [readonly]="true"
              />
              <mat-datepicker-toggle
                class="mat-picker-toggle"
                matSuffix
                [for]="credentialExpirationDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #credentialExpirationDate></mat-datepicker>
            </div>
          </div>
        </div> -->
      </form>
    </div>

    <div class="modal-footer d-flex justify-content-end">
      <button
        nbButton
        class="cancel bg-white m-2 w-100 quicksand-bold-label"
        (click)="modalService.dismissAll(modalRef); deleteProfileIfExist(); teacherPortalInfoForm.reset()"
      >
        Cancel
      </button>
      <button
        nbButton
        color="warn"
        class="save-changes-btn m-2 w-100 quicksand-bold-label"
        (click)="submit()"
        [title]="teacherPortalInfoForm.invalid ? 'Please fill all the required fields with *' : 'Save Changes'"
      >
        Save Changes
      </button>
    </div>
  </div>
</ng-template>

<!-- teacher modal -->

<ng-template #teacherValidatedModal let-modal>
  <div
    class="add-classroom-modal personal-information-modal"
    [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
  >
    <div
      class="modal-header d-flex justify-content-between align-items-center w-100"
    >
      <div class="d-flex align-items-center">
        <span class="icon-add-classroom">
          <nb-icon icon="plus-outline"></nb-icon>
        </span>
        <h6 class="add-clasroom-text quicksand-bold-label m-0">
          Authorization Subject
        </h6>
      </div>

      <span
        class="icon-close-classroom-modal d-block cursor-pointer"
        (click)="modalService.dismissAll(modalRef)"
      >
        <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
      </span>
    </div>

    <div class="modal-body">
      <div *ngIf="validatedTeacherData && validatedTeacherData.length > 0">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="quicksand-bold-label text-left">Teacher Information:</h6>
          <h6
            class="quicksand-bold-label"
            *ngIf="validatedTeacherData[0].status"
          >
            Status:
            <span
              class="quicksand-normal-label"
              [ngClass]="{
                'text-success': validatedTeacherData[0].status === 'Valid',
                'text-danger': validatedTeacherData[0].status !== 'Valid'
              }"
            >
              {{ validatedTeacherData[0].status }}
            </span>
          </h6>
        </div>

        <!-- Teacher Details in Two-Column Grid -->
        <div class="teacher-info-grid my-3">
          <div
            class="info-item"
            [ngClass]="{ 'text-danger border-red': isFirstNameMismatch }"
            *ngIf="validatedTeacherData[0].firstName"
          >
            <span class="quicksand-bold-label">First Name:</span>
            <span
              class="quicksand-normal-label"
              [ngClass]="{ 'text-danger': isFirstNameMismatch }"
              >{{ validatedTeacherData[0].firstName }}</span
            >
          </div>

          <div
            class="info-item"
            [ngClass]="{ 'text-danger border-red': isLastNameMismatch }"
            *ngIf="validatedTeacherData[0].lastName"
          >
            <span class="quicksand-bold-label">Last Name:</span>
            <span
              class="quicksand-normal-label"
              [ngClass]="{ 'text-danger': isLastNameMismatch }"
              >{{ validatedTeacherData[0].lastName }}</span
            >
          </div>

          <div class="info-item" *ngIf="validatedTeacherData[0].grade">
            <span class="quicksand-bold-label">Grade:</span>
            <span
              class="quicksand-normal-label"
              >{{ validatedTeacherData[0].grade }}</span
            >
          </div>

          <div class="info-item" *ngIf="validatedTeacherData[0].specialGrade">
            <span class="quicksand-bold-label">Special Grade:</span>
            <span
              class="quicksand-normal-label"
              >{{ validatedTeacherData[0].specialGrade }}</span
            >
          </div>

          <div class="info-item" *ngIf="validatedTeacherData[0].documentTitle">
            <span class="quicksand-bold-label">Document Title:</span>
            <span
              class="quicksand-normal-label"
              >{{ validatedTeacherData[0].documentTitle }}</span
            >
          </div>

          <div class="info-item" *ngIf="validatedTeacherData[0].documentNumber">
            <span class="quicksand-bold-label">Document Number:</span>
            <span
              class="quicksand-normal-label"
              >{{ validatedTeacherData[0].documentNumber }}</span
            >
          </div>

          <div
            class="info-item"
            *ngIf="validatedTeacherData[0].originalIssueDate"
          >
            <span class="quicksand-bold-label">Original Issue Date:</span>
            <span
              class="quicksand-normal-label"
              >{{ validatedTeacherData[0].originalIssueDate }}</span
            >
          </div>

          <div class="info-item" *ngIf="validatedTeacherData[0].issueDate">
            <span class="quicksand-bold-label">Issue Date:</span>
            <span
              class="quicksand-normal-label"
              >{{ validatedTeacherData[0].issueDate }}</span
            >
          </div>

          <div class="info-item" *ngIf="validatedTeacherData[0].expirationDate">
            <span class="quicksand-bold-label">Expiration Date:</span>
            <span
              class="quicksand-normal-label"
              >{{ validatedTeacherData[0].expirationDate }}</span
            >
          </div>
        </div>

        <!-- Authorizations -->
        <h6 class="quicksand-bold-label text-left">Authorizations:</h6>
        <div class="table-responsive">
          <table
            class="table h-100 m-0"
            *ngIf="validatedTeacherData.length > 1"
          >
            <thead>
              <tr>
                <th class="border-0"></th>
                <th class="quicksand-bold-label text-center border-0">
                  Authorization Code
                </th>
                <th class="quicksand-bold-label text-center border-0">
                  Subject Description
                </th>
                <th class="quicksand-bold-label text-center border-0">
                  Authorization Description
                </th>
                <!-- <th class="quicksand-bold-label text-center border-0">
                  Subject Code
                </th>
                <th class="quicksand-bold-label text-center border-0">
                  Subject Description
                </th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let auth of validatedTeacherData.slice(1)">
                <td class="" *ngIf="auth && auth.authorizationCode !== ''">
                  <mat-checkbox
                    class="auto-pilot custom-checkbox"
                    [(ngModel)]="auth.checked"
                  ></mat-checkbox>
                </td>
                <td
                  class="quicksand-normal-label"
                  *ngIf="auth && auth.authorizationCode !== ''"
                >
                  <p class="mt-2 quicksand-normal-label">
                    {{ auth.authorizationCode }}
                  </p>
                </td>
                <td
                  class="quicksand-normal-label text-center"
                  *ngIf="auth && auth.authorizationCode !== ''"
                >
                  <p class="mt-2 quicksand-normal-label">
                    {{ auth.subjectDescription ? auth.subjectDescription : '-' }}
                  </p>
                </td>
                <td
                  class="quicksand-normal-label"
                  *ngIf="auth && auth.authorizationCode !== ''"
                >
                  <p class="m-0 quicksand-normal-label">
                    {{ auth.authorizationDescription }}
                  </p>
                </td>

                <!-- <td
              class="quicksand-normal-label"
              *ngIf="auth && auth.subjectCode !== ''"
              >
              <p class="m-0 quicksand-normal-label">
                {{ auth.subjectCode }}
              </p>
            </td>

            <td
            class="quicksand-normal-label"
            *ngIf="auth && auth.subjectDescription !== ''"
            >
            <p class="m-0 quicksand-normal-label">
              {{ auth.subjectDescription }}
            </p>
          </td> -->
              </tr>
            </tbody>
          </table>
          <div *ngIf="validatedTeacherData.length < 1" class="text-center pr-5">
            <img
              src="/assets/images/respond-edu.svg"
              height="150"
              width="150"
              alt="no-data-found"
            />
            <h6 class="quicksand-bold-label">No Data Found!</h6>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer d-flex justify-content-end">
      <button
        nbButton
        class="cancel bg-white m-2 w-100 quicksand-bold-label"
        (click)="modalService.dismissAll(modalRef)"
      >
        Cancel
      </button>
      <button
        (click)="handleSaveChanges()"
        nbButton
        color="warn"
        class="save-changes-btn m-2 w-100 quicksand-bold-label"
      >
        Save Changes
      </button>
    </div>
  </div>
</ng-template>
